import template from './notificationBar.html' with { type: 'html' };

export default {
	name: 'CNotificationBar',
	props: {
		connectionIsOnline: {
			type: Boolean,
			default: false
		},
		hasDisclaimer: {
			type: Boolean,
			default: false
		},
		isCookieEnabled: {
			type: Boolean,
			default: false
		},
		isObsoleteMac: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			notifications: {
				cookie: {
					type: 'cookie',
					display: !this.isCookieEnabled,
					path: `https://support.avast.com/${this.url.locale}/article/Enable-JavaScript-cookies`,
					style: '-error'
				},
				disclaimer: {
					type: 'disclaimer',
					display: this.hasDisclaimer,
					style: '-warning'
				},
				offline: {
					type: 'offline',
					display: !this.connectionIsOnline,
					style: '-error'
				},
				obsoleteMac: {
					type: 'obsoleteMac',
					display: this.isObsoleteMac,
					style: '-error'
				}
			}
		};
	},
	computed: {
		notificationText() {
			return {
				cookie: this.t('notificationBar_cookie'),
				disclaimer: this.order?.disclaimer,
				offline: this.t('notificationBar_offline'),
				obsoleteMac: this.t('notificationBar_obsoleteMac')
			};
		}
	},
	watch: {
		isCookieEnabled(newValue) {
			this.notifications.cookie.display = !newValue;
		},
		connectionIsOnline(newValue) {
			this.notifications.offline.display = !newValue;
		},
		isObsoleteMac(newValue) {
			this.notifications.isObsoleteMac.display = !newValue;
		},
		hasDisclaimer(newValue) {
			this.notifications.disclaimer.display = !newValue;
		}
	},
	template
};
